<template>
  <section
    class="section storiesToRediscover"
    :class="{
      '-light': bg_color === 'light',
      '-dark': bg_color === 'dark',
    }"
  >
    <div class="storiesToRediscover__header">
      <Image v-if="logo" :source="logo" sizes="163px" class="storiesToRediscover__logo" />

      <h2 class="storiesToRediscover__title">
        {{ title }}
      </h2>

      <p v-if="description" class="storiesToRediscover__description">
        {{ description }}
      </p>
    </div>

    <div v-if="carousel.length" class="storiesToRediscover__hero">
      <Swiper
        ref="swiper-stories"
        key="swiper-stories"
        :slides-per-view="1"
        :modules="swiper.modules"
        :pagination="swiper.pagination"
        :loop="true"
        class="swiper-image swiper2 storiesToRediscover__hero-swiper"
      >
        <SwiperSlide
          v-for="(item, key) in carousel"
          :key="item.flexKey || `img-${key}`"
          class="swiper-image__image storiesToRediscover__hero-slide"
          :style="{
            backgroundImage: `url(${
              item.image ? item.image.lg || item.image.md || item.image.original : ''
            })`,
          }"
        >
          <div v-if="item.location" class="storiesToRediscover__location">
            {{ item.location }}

            <div v-if="item.alt">
              {{ item.alt }}
            </div>
          </div>
        </SwiperSlide>

        <SectionSwiperControls :items-count="carousel.length" always-show />
      </Swiper>
    </div>
  </section>
</template>

<script>
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

import SectionSwiperControls from '@/components/blocks/SectionSwiperControls.vue'
import Image from '@/components/global/Image.vue'

export default {
  name: 'SectionStoriesToRediscover',

  components: {
    Image,
    SectionSwiperControls,
    Swiper,
    SwiperSlide,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    description: {
      type: String,
      default: '',
    },

    logo: {
      type: Object,
      default: null,
    },

    bg_color: {
      type: String,
      default: 'light',
    },

    carousel: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      swiper: {
        modules: [Pagination],
        slideToClickedSlide: true,
        grabCursor: true,

        pagination: {
          clickable: true,
          horizontalClass: 'swipe-horizontal__higher',
          bulletClass: 'swipe-bullet -blue',
          bulletActiveClass: 'swipe-bullet-active',
        },
      },
    }
  },
}
</script>
